import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconLeaderboardsOn = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    viewBox="0 0 25 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-leaderboards-on_svg__a)"
      d="M23.5 10.5c.797 0 1.5.703 1.5 1.5 0 .844-.703 1.5-1.5 1.5h-12A1.48 1.48 0 0 1 10 12c0-.797.656-1.5 1.5-1.5h12ZM11.5 6A1.48 1.48 0 0 1 10 4.5c0-.797.656-1.5 1.5-1.5h12c.797 0 1.5.703 1.5 1.5 0 .844-.703 1.5-1.5 1.5h-12Zm12 12c.797 0 1.5.703 1.5 1.5 0 .844-.703 1.5-1.5 1.5h-12a1.48 1.48 0 0 1-1.5-1.5c0-.797.656-1.5 1.5-1.5h12ZM2.875 10.5c-.656 0-1.125-.469-1.125-1.125 0-.61.469-1.125 1.125-1.125h.75V4.594c-.516.187-1.078-.047-1.36-.516-.328-.516-.14-1.219.376-1.547l1.5-.844c.375-.234.796-.234 1.125 0 .375.188.609.563.609.938V8.25h.75c.61 0 1.125.422 1.125 1.125A1.11 1.11 0 0 1 6.625 10.5h-3.75Zm4.5 9.75c.61 0 1.125.516 1.125 1.172 0 .61-.516 1.078-1.125 1.078H2.078c-.422 0-.844-.281-1.031-.703-.14-.422-.047-.938.328-1.219l3.89-3.515c.516-.422.563-1.125.141-1.594a.92.92 0 0 0-.797-.422 1.037 1.037 0 0 0-.89.281l-.61.516a1.168 1.168 0 0 1-1.593-.14 1.168 1.168 0 0 1 .14-1.595l.563-.515c.703-.61 1.64-.89 2.531-.797a3.24 3.24 0 0 1 2.39 1.219c1.173 1.406 1.032 3.515-.374 4.734l-1.735 1.5h2.344Z"
    />
    <defs>
      <linearGradient
        id="icon-leaderboards-on_svg__a"
        x1={25}
        x2={1}
        y1={0}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconLeaderboardsOn;
